import { takeEvery, call, select } from 'redux-saga/effects';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';

import { selectActiveVenueId } from 'selectors/general';
import { upcomingSpotsAndBookings as upcomingSpotsAndBookingsEntity } from 'store/saga/entities/bound';
import { ACTIVE_VENUE_CHANGED } from 'features/App';

export function* doFetchSpotsAndBookingsSummary(client, action) {
  const { venueId } = action;
  yield call(fetchEntityIfNeeded, upcomingSpotsAndBookingsEntity, [client, venueId]);
}

export function* handleSpotsAndBookingsRouteEnter(client) {
  const venueId = yield select(selectActiveVenueId);
  yield call(doFetchSpotsAndBookingsSummary, client, { venueId });
}

export function* watchSpotsAndBookingsModule(client) {
  yield takeEvery(ACTIVE_VENUE_CHANGED, doFetchSpotsAndBookingsSummary, client);
}
